import React from "react";
import { Check } from "lucide-react";
import { Section } from "../WsField";
import { SourceTag } from "../SourceTag";

export function PackageSection({ data, ws, setWs, zh, canEdit }) {
  const L = data.srcLabels; const S = data.sources || {};
  const pkgs = data.template?.packages || [];
  const cfgItems = data.template?.configItems || [];
  const cfg = ws.config || {};
  const setCfg = (k, v) => setWs({ ...ws, config: { ...cfg, [k]: v } });
  return (
    <Section id="package" title={zh ? "④ 配置套餐与配置表" : "④ Package & Configuration"} subtitle={zh ? "套餐来自合同模板正文；未选套餐前合同正文保留全部套餐段落（待补全）" : "Packages come from the template body; unselected = pending"}
      badge={<SourceTag src={S.packageKey} labels={L} zh={zh} testid="ws-package-src" />}>
      {pkgs.length > 0 && (
        <div className={`grid gap-2 ${pkgs.length > 1 ? "grid-cols-3" : "grid-cols-1"}`} data-testid="ws-packages">
          {pkgs.map((p) => {
            const on = ws.packageKey === p.key;
            return (
              <button key={p.key} data-testid={`ws-package-${p.key}`} data-on={on ? 1 : 0} disabled={!canEdit} onClick={() => setWs({ ...ws, packageKey: on && pkgs.length > 1 ? "" : p.key })}
                className={`text-left rounded-xl border p-3 transition-colors ${on ? "border-brand-400 bg-brand-50/60 ring-1 ring-brand-200" : "border-slate-200 hover:border-slate-300"} disabled:cursor-default`}>
                <div className="flex items-center justify-between"><span className="text-[13px] font-semibold text-slate-800">{p.name}</span>{on && <Check className="h-4 w-4 text-brand-600" />}</div>
                <ul className="mt-1.5 space-y-0.5 text-[11px] text-slate-500 max-h-28 overflow-y-auto">{p.items.slice(0, 14).map((it, i) => <li key={i} className="truncate">· {it}</li>)}</ul>
              </button>
            );
          })}
        </div>
      )}
      {pkgs.length > 1 && !ws.packageKey && <p data-testid="ws-package-pending" className="text-[11.5px] text-red-600">{zh ? "请选择套餐 —— 未选择时合同正文会保留全部套餐段落。" : "Select a package — otherwise all package blocks stay in the body."}</p>}
      {cfgItems.length > 0 && (
        <div>
          <p className="text-[12px] font-semibold text-slate-600 mb-1.5">{zh ? "配置表（客户签字页 · 与模板同格）" : "Configuration table (signature page)"}</p>
          <div className="grid grid-cols-2 gap-x-4 gap-y-1.5" data-testid="ws-config-table">
            {cfgItems.map((it) => (
              <label key={it.key} className="flex items-center gap-2 text-[12px]">
                <span className="flex-1 text-slate-600 truncate" title={it.label}>{it.label}</span>
                <input data-testid={`ws-config-${it.key}`} value={cfg[it.key] ?? ""} disabled={!canEdit} onChange={(e) => setCfg(it.key, e.target.value)} placeholder={it.default}
                  className="w-28 text-[12px] text-center rounded-md border border-slate-200 px-1.5 py-1 focus:outline-none focus:border-brand-400 disabled:bg-slate-50" />
              </label>
            ))}
          </div>
          <p className="text-[10.5px] text-slate-400 mt-1">{zh ? "「-」= 不含；数量 / 说明直接填写。" : "\"-\" = not included; enter quantity or note."}</p>
        </div>
      )}
    </Section>
  );
}
